import React, { Component } from "react";
import _ from 'lodash';

// UI Components
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

import { getMessage } from "CONFIG/i18n";

import "../AdminDashboard.less";
import "./SessionList.less";

import { convertSecondsTohhmm } from "UTILS/DateUtils";
import { getBootstrapTableOptions } from "UTILS/Utility";

export default class encodingTime extends Component{

  constructor(props){
    super(props);
    this.state={
      showSessionDetailsFlag: 1,
    };
  }

  showSessionDetails = () =>{
    this.setState({ showSessionDetailsFlag : 0 });
  }

  fetchAggregationItems = (cell, row) => {
    return (
      <div>
        <label
          className="nameEllipsis"
          title={row.encoding_time_month}
        >
          {getMessage(row.encoding_time_month)}
        </label>
      </div>
    )
  }

  fetchIssuanceCount = (cell, row) => {
    return (
      <div>
        <label
          title={row.encoding_time_count}>
          {convertSecondsTohhmm(row.encoding_time_count)}
        </label>
      </div>
    )
  }

  render(){
    const { encodingTimeList } = this.props;
    return(
      (this.state.showSessionDetailsFlag) ?
        <div className="reportListContainer">
          <BootstrapTable
            keyField="encoding_time_month"
            data={encodingTimeList}
            tableHeaderClass="tableHeader"
            tableBodyClass='tableBody'
            containerClass='organisationsList reportList'
            tableContainerClass=''
            headerContainerClass=''
            bodyContainerClass=''
            bordered={false}
            options={getBootstrapTableOptions()}
            printable
          >
            <TableHeaderColumn
              dataField='session_key'
              hidden={true}
            >
              {getMessage("SESSION_KEY")}
            </TableHeaderColumn>
            <TableHeaderColumn
              dataFormat={this.fetchAggregationItems}
            >
              {getMessage("AGGREGATION_ITEMS")}
            </TableHeaderColumn>
            <TableHeaderColumn
              dataFormat={this.fetchIssuanceCount}
            >
              {getMessage("ENCODING_TIME_COUNT")}
            </TableHeaderColumn>
          </BootstrapTable>

        </div>:null
    )

  }

}
